import script from "./news-and-events-band.vue?vue&type=script&lang=js"
export * from "./news-and-events-band.vue?vue&type=script&lang=js"

import "./news-and-events-band.vue?vue&type=style&index=0&id=05bb583f&lang=scss"

const __exports__ = script;

export default __exports__